import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBurger, faChevronDown, faChevronUp, faCog, faX } from '@fortawesome/free-solid-svg-icons';
import { routesConfig, routesConfigAdmin, RouteType } from '../../routes'; // Importa il tuo routesConfig
import { useAuth } from '../../context/authContext';
import { formatUserName } from '../../utils/main';
import * as PKJ from "../../../package.json";
import { useLanguage } from '../../context/languageContext';

const Navbar = () => {
    const [activeButton, setActiveButton] = useState<string | null>(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [navBarVisible, setNavBarVisible] = useState<boolean>(false);
    const nav = useNavigate();
    const { t } = useLanguage();

    const { user, logout, association, associationRole } = useAuth();

    const navigate = (path: string) => {
        setNavBarVisible(false);
        nav(path);
    };

    const handleMainButtonClick = (buttonName: string) => {
        setActiveButton(activeButton === buttonName ? null : buttonName);
    };

    const groupedRoutes = routesConfig.reduce((acc: { [key: string]: RouteType[] }, route: RouteType) => {
        // Controlla se l'utente ha accesso alla rotta
        console.log(associationRole);
        
        const hasAccess = !route.deny.includes(associationRole) && (route.onNav === undefined || route.onNav);

        if (hasAccess) {
            if (route.group) {
                if (!acc[route.group]) acc[route.group] = [];
                acc[route.group].push(route);
            } else {
                acc['default'] = acc['default'] || [];
                acc['default'].push(route);
            }
        }

        return acc;
    }, {} as { [key: string]: RouteType[] });

    const groupedRoutesAdmin = routesConfigAdmin.reduce((acc: { [key: string]: RouteType[] }, route: RouteType) => {
        // Controlla se l'utente ha accesso alla rotta
        const hasAccess = !route.deny.includes(associationRole) && (route.onNav === undefined || route.onNav);

        if (hasAccess) {
            if (route.group) {
                if (!acc[route.group]) acc[route.group] = [];
                acc[route.group].push(route);
            } else {
                acc['default'] = acc['default'] || [];
                acc['default'].push(route);
            }
        }

        return acc;
    }, {} as { [key: string]: RouteType[] });

    return (
        <div>
            <nav className={`navbar ${navBarVisible ? "visible" : ""}`}>
                <div className="navbar-title">
                    <span>SportifyApp </span>
                    <FontAwesomeIcon className="close" icon={faX} onClick={() => setNavBarVisible(false)} />
                </div>
                <span className='association-name'><span>{t('navbar.connectedTo')} {association.name}</span></span>

                <h3>{t('navbar.athletes')}</h3>

                <div className="navbar-buttons">
                    {/* Mappa le route di default */}
                    {groupedRoutes['default']?.map((route: RouteType) => (
                        (route.onNav !== false) && (route.onNav === undefined || route.onNav === true) && (
                            <div key={route.path} className="navbar-button" onClick={() => navigate(route.path)}>
                                {route.nameKey ? t(route.nameKey) : route.name}
                            </div>
                        )
                    ))}

                    {Object.keys(groupedRoutes).map((group) =>
                        group !== 'default' && groupedRoutes[group].length > 0 && (
                            <div key={group}>
                                <div className={`navbar-button ${activeButton === group ? "active" : ""}`} onClick={() => handleMainButtonClick(group)}>
                                    {groupedRoutes[group]?.[0]?.groupKey ? t(groupedRoutes[group][0].groupKey) : group.charAt(0).toUpperCase() + group.slice(1)}
                                    <FontAwesomeIcon className='arrow' icon={activeButton === group ? faChevronUp : faChevronDown} />
                                </div>
                                {activeButton === group && (
                                    <div className="navbar-subbuttons">
                                        {groupedRoutes[group]?.map((route: RouteType) => (
                                            <button key={route.path} className="navbar-subbutton" onClick={() => navigate(route.path)}>
                                                {route.nameKey ? t(route.nameKey) : route.name}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )
                    )}
                </div>

                {Object.keys(groupedRoutesAdmin).length > 0 && (
                    <h3>{t('navbar.administration')}</h3>
                )}
                <div className="navbar-buttons">
                    {/* Mappa le route di default */}
                    {groupedRoutesAdmin['default']?.map((route: RouteType) => (
                        (route.onNav !== false) && (route.onNav === undefined || route.onNav === true) && (
                            <div key={route.path} className="navbar-button" onClick={() => navigate(route.path)}>
                                {route.nameKey ? t(route.nameKey) : route.name}
                            </div>
                        )
                    ))}

                    {Object.keys(groupedRoutesAdmin).map((group) =>
                        group !== 'default' && groupedRoutesAdmin[group].length > 0 && (
                            <div key={group}>
                                <div className={`navbar-button ${activeButton === group ? "active" : ""}`} onClick={() => handleMainButtonClick(group)}>
                                    {groupedRoutesAdmin[group]?.[0]?.groupKey ? t(groupedRoutesAdmin[group][0].groupKey) : group.charAt(0).toUpperCase() + group.slice(1)}
                                    <FontAwesomeIcon className='arrow' icon={activeButton === group ? faChevronUp : faChevronDown} />
                                </div>
                                {activeButton === group && (
                                    <div className="navbar-subbuttons">
                                        {groupedRoutesAdmin[group]?.map((route: RouteType) => (
                                            <button key={route.path} className="navbar-subbutton" onClick={() => navigate(route.path)}>
                                                {route.nameKey ? t(route.nameKey) : route.name}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )
                    )}
                </div>
                <footer className='copy'>JAWS Developers ({PKJ.version})</footer>
            </nav>

            <div className='user'>
                <div className={`user-name ${isDropdownOpen ? 'open' : ''}`} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    {formatUserName(user.name, user.surname)}
                </div>
                {isDropdownOpen && (
                    <div className='dropdown-menu'>
                        <button onClick={() => navigate("/auth")}>{t('navbar.changeAssociation')}</button>
                        <button className='logout' onClick={logout}>{t('navbar.logout')}</button>
                    </div>
                )}
                <div className={`profile-picture`}>
                    <img src={user.profile_picture === "" ? 'https://assets.sportifyapp.co/images/user.png' : user.profile_picture} />
                </div>
                <div className={`settings`} onClick={() => navigate("/settings")}>
                    <FontAwesomeIcon icon={faCog} />
                </div>
            </div>

            <div className='navbutton'>
                <div className='navbutton-icon' onClick={() => setNavBarVisible(true)}>
                    <FontAwesomeIcon icon={faBurger} />
                </div>
            </div>
            
            
        </div>
    );
};

export default Navbar;
